import mirtaImg from "./Mirta_Torres.jpg";
import leandroImg from "./Leandro_Almeida.jpg";
import harlleyImg from "./Harlley_Dantas.jpg";

const teamIndex = [
  {
    name: "Mirta Berdeguez",
    role: "MirtaRole",
    photo: mirtaImg,
    linkedin: "https://www.linkedin.com/in/mirtabarbaratorresberdeguez/",
  },
  {
    name: "Harlley Hauradou",
    role: "HarlleyRole",
    photo: harlleyImg,
    linkedin: "https://www.linkedin.com/in/harlley-hauradou/",
  },
  {
    name: "Leandro Almeida",
    role: "LeandroRole",
    photo: leandroImg,
    linkedin: "https://www.linkedin.com/in/leandro-almeida-4b956872/",
  },
];

export default teamIndex;

